import React, { useState, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import Comission from '../../../../services/Comission'
import General from '../../../../services/General'
import Navbar from '../../../../components/Navbar'
import ProfessionalCreditList from '../../../../components/Lists/ProfessionalCreditList'
import Logo from '../../../../icons/logo-cutilei-simple.png'
import { DateTime } from 'luxon'
import { LabelRow, EarningContainer, Image } from './styles'

import { 
  Container,
  InfoText,
  InfoContainer,
  TabButton,
  Row,
  Info,
  SubTitle,
  MoneyTextMask,
  ListContainer
} from '../../styles'

function Total ({ history }) {
  const {
    dateRange, earningType, category, monthTotal,
    businessEarnings, professionalEarnings, selectedProfessional
  } = history.location.state
  
  const startDate = DateTime.fromJSDate (dateRange[0]).toFormat ('dd/MM/yyyy')
  const endDate = DateTime.fromJSDate (dateRange[1]).toFormat ('dd/MM/yyyy')
  const [earningsByPeriod, setEarningsByPeriod] = useState (history.location.state.earningsByPeriod)
  const [earningsByType, setEarningsByType] = useState ([])
  const [earningsByService, setEarningsByService] = useState ([])
  const [bonuses, setBonuses] = useState ([])
  const [discounts, setDiscounts] = useState ([])
  const [bonusTotal, setBonusTotal] = useState (0)
  const [discountTotal, setDiscountTotal] = useState (0)
  const [filteredEarningsByPeriod, setFilteredEarningsByPeriod] = useState ([])
  const [typeOption, setTypeOption] = useState (earningType.value === 'all_earnings' ? {
    label: 'Comandas do salão', value: 'bill'
  } : earningType)
  const [earningOption, setEarningOption] = useState ({label: 'Serviços', value: 'services'})

  const TYPE_OPTION_LIST = [
    {label: 'Comandas do salão', value: 'bill'},
    {label: 'Agendamentos Cutilei', value: 'cutilei'}
  ]

  const EARNING_OPTION_LIST = [
    {label: 'Serviços', value: 'services'},
    {label: 'Produtos', value: 'products'},
    {label: 'Pacotes', value: 'bundles'},
    selectedProfessional.value !== 'all_professionals' && {label: 'Caixinhas', value: 'tips'},
    bonuses.length > 0 && {label: 'Bônus', value: 'bonuses'},
    discounts.length > 0 && {label: 'Descontos', value: 'discounts'}
  ].filter (o => o)

  useEffect (() => {
    setBonuses (earningsByPeriod.filter (earning => earning.type === 'bonus'))
    setDiscounts (earningsByPeriod.filter (earning => earning.type === 'discount'))
  }, [earningsByPeriod])

  useEffect (() => {
    if (typeOption.value === 'cutilei') handleCutileiEarningsSelected ()
    else if (typeOption.value === 'bill') handleBusinessEarningsSelected ()
  }, [typeOption])

  useEffect (() => {
    if (typeOption.value === 'bill') handleBusinessEarningsSelected ()
  }, [earningOption, earningsByPeriod])

  useEffect (() => {
    setBonusTotal (bonuses.reduce ((total, bonus) => total + bonus.value, 0))
  }, [bonuses])

  useEffect (() => {
    setDiscountTotal (discounts.reduce ((total, bonus) => total + bonus.value, 0))
  }, [discounts])

  const handleCutileiEarningsSelected = () => {
    const cutileiEarnings = earningsByPeriod.filter (earning => earning.type === 'cutilei')
    
    setEarningsByType (cutileiEarnings)
    setFilteredEarningsByPeriod (cutileiEarnings)
    setEarningsByService (General.groupBy (cutileiEarnings.map (earning => ({
      ...earning, item_name: earning.service?.name
    })), 'item_name'))
  }

  const handleBusinessEarningsSelected = () => {
    let earningsByType = []
    let filteredEarningsByPeriod = []
    const businessEarnings = earningsByPeriod.filter (earning => earning.type === 'bill')
    const schedules = []
    const services = []
    const products = []
    const bundles = []
    const tips = []

    switch (earningOption.value) {
      case 'services': {
        filteredEarningsByPeriod = businessEarnings
          .filter (earning => earning.services?.length > 0 || earning.schedules?.length > 0)
          .map (earning => ({...earning, products, bundles, tips}))

        earningsByType = [
          ...businessEarnings.reduce ((acc, earning) => acc.concat (earning.services), []),
          ...businessEarnings.reduce ((acc, earning) => acc.concat (earning.schedules), [])
        ]; break
      }
      case 'products': {
        filteredEarningsByPeriod = businessEarnings.filter (earning => (
          earning.products.length > 0
        )).map (earning => ({...earning, schedules, services, bundles, tips}))

        earningsByType = businessEarnings.reduce ((acc, e) => acc.concat (e.products), []); break
      }
      case 'bundles': {
        filteredEarningsByPeriod = businessEarnings.filter (earning => (
          earning.bundles.length > 0
        )).map (earning => ({...earning, schedules, services, products, tips}))

        earningsByType = businessEarnings.reduce ((acc, e) => acc.concat (e.bundles), []); break
      }
      case 'bonuses': {
        const filteredBonuses = earningsByPeriod.filter (earning => earning.type === 'bonus')
        filteredEarningsByPeriod = filteredBonuses
        earningsByType = filteredBonuses; break
      }
      case 'discounts': {
        const filteredDiscounts = earningsByPeriod.filter (earning => earning.type === 'discount')
        filteredEarningsByPeriod = filteredDiscounts
        earningsByType = filteredDiscounts; break
      }
      default: {
        filteredEarningsByPeriod = businessEarnings.filter (earning => (
          earning.tips.length > 0
        )).map (earning => ({...earning, schedules, services, products, bundles}))

        earningsByType = businessEarnings.reduce ((acc, e) => acc.concat (e.tips), []); break
      }
    }
    setEarningsByType (earningsByType)
    setEarningsByService (General.groupBy (
      earningsByType.filter (earning => category
        ? [earning.service?.category?.id, earning.category?.id].includes (category.value)
        : true
      ).map (earning => ({
        ...earning,
        item_name: earning?.name ?? earning?.description ?? earning?.service?.name
      })),
      'item_name'
    ))
    setFilteredEarningsByPeriod (filteredEarningsByPeriod)
  }

  const freeServices = service => !service.bundle_id
  const sumItemsTotal = (total, item) => total + (item.custom_price ?? item.price ?? 0)
  const sumBusinessItemsTotal = (total, item) => (
    total + (item.custom_price ?? item.price ?? item.value) * (
      1 - (item.comission_percentage ?? (item.professional_id ? item.custom_comission_percentage : 0))
    )
  )
  const sumProfessionalItemsTotal = (total, item) => (
    total + (item.discount_price ?? item.custom_price ?? item.price ?? item.value) * (
      item.comission_percentage ?? (item.professional_id ? item.custom_comission_percentage : 0)
    )
  )

  const handleDeleteCredit = credit => {
    const index = EARNING_OPTION_LIST.findIndex (o => o && o.value === earningOption.value)
    setEarningsByPeriod (earningsByPeriod.filter (e => e.id !== credit.id))
    setEarningOption (EARNING_OPTION_LIST [index - 1])
  }

  return (
    <Container>
      <Navbar/>
      <InfoContainer style={{alignItems: 'center'}}>
        <SubTitle style={{marginBottom: 7}}>
          Total do período ({startDate} - {endDate}) - {selectedProfessional.label}
        </SubTitle>
        <Info style={{alignItems: 'center', height: 'auto'}}>
          <Row>
            <InfoText>Faturamento bruto:</InfoText>
            <MoneyTextMask value={monthTotal}/>
          </Row>
          <Row>
            <InfoText>
              Comissão {
                selectedProfessional.value === 'all_professionals'
                  ? 'dos profissionais: ' : 'do profissional: '
              }
            </InfoText>
            <MoneyTextMask value={professionalEarnings}/>
          </Row>
          {bonuses.length > 0 && (
            <Row>
              <InfoText>Bônus do profissional:</InfoText>
              <MoneyTextMask value={bonusTotal ?? 0}/>
            </Row>
          )}
          {discounts.length > 0 && (
            <Row>
              <InfoText>Descontos do profissional:</InfoText>
              <MoneyTextMask value={discountTotal ?? 0}/>
            </Row>
          )}
          <Row>
            <SubTitle>Comissão do salão:</SubTitle>
            <MoneyTextMask value={businessEarnings}/>
          </Row>
        </Info>
      </InfoContainer>
      {earningType.value === 'all_earnings' && (
        <Row>
          {TYPE_OPTION_LIST.map ((o, index) =>
            <TabButton
              key={index}
              selected={typeOption.value === o.value}
              color={typeOption.value === o.value ? '#FFC100' : '#FFFFFF'}
              onClick={() => setTypeOption (o)}
              style={{width: 190}}
            >
              {o.label}
            </TabButton>
          )}
        </Row>
      )}
      {typeOption.value === 'bill' && (
        <Row>
          {EARNING_OPTION_LIST.map ((o, index) =>
            <TabButton
              key={index}
              selected={earningOption.value === o.value}
              color={earningOption.value === o.value ? '#FFC100' : '#FFFFFF'}
              onClick={() => setEarningOption (o)}
            >
              {o.label}
            </TabButton>
          )}
        </Row>
      )}
      <ListContainer>
        {['bonuses', 'discounts'].includes (earningOption.value) ? (
          <ProfessionalCreditList
            credits={filteredEarningsByPeriod}
            type={earningOption.value === 'bonuses' ? 'bonus' : 'discount'}
            onEdit={credit => {
              setEarningsByPeriod (earningsByPeriod.map (e => e.id === credit.id ? {...credit} : e))
            }}
            onDelete={handleDeleteCredit}
            styles={{width: 960, minWidth: 840}}
          />
        ) : (
          <>
            <LabelRow>
              <SubTitle>{earningOption.label}</SubTitle>
              <SubTitle>Qtd.</SubTitle>
              <SubTitle>Total bruto</SubTitle>
              <SubTitle>Comissões</SubTitle>
              <SubTitle>Total líquido</SubTitle>
            </LabelRow>
            <EarningContainer>
              <SubTitle>TOTAL</SubTitle>
              <SubTitle>{earningsByType.length}</SubTitle>
              <MoneyTextMask value={(Comission.getTotalEarnings (filteredEarningsByPeriod, typeOption, category))}/>
              <MoneyTextMask value={(Comission.getProfessionalEarnings (filteredEarningsByPeriod, typeOption, category))}/>
              <MoneyTextMask value={(Comission.getBusinessEarnings (filteredEarningsByPeriod, typeOption, category))}/>
            </EarningContainer>
            {earningsByService.length > 0 && earningsByService.map ((earnings, index) => {
              const totalEarnings = earnings.filter (freeServices).reduce (sumItemsTotal, 0)
              const businessEarnings = earnings.filter (freeServices).reduce (sumBusinessItemsTotal, 0)
              const professionalEarnings = earnings.reduce (sumProfessionalItemsTotal, 0)
  
              return (
                <EarningContainer key={index}>
                  <Row>
                    {earnings[0].cutilei_schedule && <Image src={Logo} alt='Service Cutilei'/>}
                    <SubTitle>
                      {earnings[0]?.name ?? earnings[0]?.service?.name ?? earnings[0]?.description}
                    </SubTitle>
                  </Row>
                  <SubTitle>{earnings.length}</SubTitle>
                  <MoneyTextMask value={totalEarnings}/>
                  <MoneyTextMask value={professionalEarnings}/>
                  <MoneyTextMask value={businessEarnings}/>
                </EarningContainer>
              )
            })}
          </>
        )}
      </ListContainer>
    </Container>
  )
}

export default withRouter (Total)
